// import React, { useState, useEffect, useMemo } from 'react';
// import { useSelector } from 'react-redux';
// import Sidebar from '../Core/Sidebar';
// import Navbar from '../Core/Navbar';
// import { Search, Filter, Download, Calendar, ArrowUpRight, CreditCard } from 'lucide-react';
// import * as XLSX from 'xlsx';
// import { toast } from 'react-toastify';
// import '../../Dashboard Style/WalletTransaction.css'; // Reusing your existing CSS

// const ZeroIncome = ({ title, incomeType }) => {
//   const authToken = useSelector((state) => state.user?.token);
//   const [sidebarOpen, setSidebarOpen] = useState(true);
//   const [transactions, setTransactions] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [perPage, setPerPage] = useState(15);
//   const [searchQuery, setSearchQuery] = useState('');
//   const [dateFilter, setDateFilter] = useState('all');
//   const [originalTransactions, setOriginalTransactions] = useState([]);
  

//   const toggleSidebar = () => {
//       setSidebarOpen(!sidebarOpen);
//     };
  
//     // Initialize sidebar functionality (same as in Dashboard)
//     useEffect(() => {
//       const sidebar = document.querySelector('.sidebar');
//       const sidebarBody = document.querySelector('.sidebar-body');
      
//       if (sidebar) {
//         if (sidebarOpen) {
//           sidebar.classList.remove('close');
//         } else {
//           sidebar.classList.add('close');
//         }
//       }
      
//       // Add custom scrollbar to sidebar body
//       if (sidebarBody) {
//         sidebarBody.style.height = 'calc(100vh - 70px)';
//         sidebarBody.style.overflowY = 'auto';
//       }
  
//       return () => {
//         // Cleanup
//       };
//     }, [sidebarOpen]);
  
//     useEffect(() => {
//       // Add custom scrollbar styles for sidebar
//       const style = document.createElement('style');
//       style.innerHTML = `
//         /* Custom scrollbar for sidebar */
//         .sidebar-body {
//           height: calc(100vh - 70px);
//           overflow-y: auto;
//         }
        
//         .sidebar-body::-webkit-scrollbar {
//           width: 6px;
//         }
        
//         .sidebar-body::-webkit-scrollbar-track {
//           background: rgba(255, 255, 255, 0.05);
//           border-radius: 10px;
//         }
        
//         .sidebar-body::-webkit-scrollbar-thumb {
//           background: rgba(255, 255, 255, 0.2);
//           border-radius: 10px;
//         }
        
//         .sidebar-body::-webkit-scrollbar-thumb:hover {
//           background: rgba(255, 255, 255, 0.3);
//         }
        
//         /* Sidebar dropdown menu styles */
//         .sidebar .nav-dropdown {
//           list-style: none;
//           padding-left: 0;
//           max-height: 0;
//           overflow: hidden;
//           transition: max-height 0.3s ease;
//         }
        
//         .sidebar .nav-dropdown.show {
//           max-height: 500px;
//         }
        
//         .sidebar .nav-dropdown-item {
//           padding-left: 2.5rem;
//         }
        
//         /* Sidebar dropdown toggle with icon */
//         .nav-item.has-dropdown .nav-link {
//           position: relative;
//           padding-right: 2.5rem;
//         }
        
//         .nav-item.has-dropdown .dropdown-icon {
//           position: absolute;
//           right: 1rem;
//           top: 50%;
//           transform: translateY(-50%);
//           transition: transform 0.3s ease;
//         }
        
//         .nav-item.has-dropdown .nav-link[aria-expanded="true"] .dropdown-icon {
//           transform: translateY(-50%) rotate(180deg);
//         }
        
//         /* Improved dropdown styling similar to first image */
//         .nav-item.has-dropdown .nav-dropdown {
//           background: rgba(255, 255, 255, 0.05);
//           border-left: 3px solid var(--primary-color, #0d6efd);
//           margin-left: 1rem;
//           border-radius: 0 0 8px 8px;
//         }
        
//         .nav-item.has-dropdown .nav-dropdown-item .nav-link {
//           padding: 0.75rem 1rem 0.75rem 2rem;
//           color: rgba(255, 255, 255, 0.8);
//         }
        
//         .nav-item.has-dropdown .nav-dropdown-item .nav-link:hover {
//           background: rgba(255, 255, 255, 0.1);
//           color: white;
//         }
        
//         /* Fix for category text styling */
//         .nav-item.has-dropdown .link-title.nav-item.nav-category {
//           font-weight: 600;
//           font-size: 0.875rem;
//           text-transform: uppercase;
//           letter-spacing: 0.5px;
//         }
        
//         /* Smooth transitions */
//         .sidebar {
//           transition: all 0.3s ease;
//         }
//       `;
//       document.head.appendChild(style);
  
//       return () => {
//         document.head.removeChild(style);
//       };
//     }, []);

//   const fetchIncomeData = async () => {
//     try {
//       setLoading(true);
//       const response = await fetch(`https://global.thewillowquantum.com/api/user/get-wallet-transaction`, {
//         method: 'POST',
//         headers: {
//           'Authorization': `Bearer ${authToken}`,
//           'Content-Type': 'application/x-www-form-urlencoded',
//         },
//         body: new URLSearchParams({
//           wallet_type: incomeType, // Dynamic based on route
//           per_page: perPage.toString(),
//           page: currentPage.toString()
//         })
//       });

//       const data = await response.json();
//       if (data.status) {
//         setTransactions(data.data || []);
//         setTotalPages(data.pagination?.last_page || 1);
//       } else {
//         toast.error(data.message || `Failed to fetch ${title}`);
//       }
//     } catch (error) {
//       toast.error("Connection Error");
//     } finally {
//       setLoading(false);
//     }
//   };

//     const handleDateFilterChange = (filter) => {
//       setDateFilter(filter);
//       setCurrentPage(1);
//       toast.info(`Date filter changed to ${filter === 'all' ? 'All Time' : filter}`);
//     };

//       const handleSearch = (e) => {
//     e.preventDefault();
//     // Search is handled by filteredTransactions memo
//   };

//    const filteredTransactions = useMemo(() => {
//       let filtered = [...originalTransactions];
  
//       // Apply search filter
//       if (searchQuery.trim()) {
//         const query = searchQuery.toLowerCase();
//         filtered = filtered.filter(transaction => 
//           transaction.transaction_id?.toString().toLowerCase().includes(query) ||
//           transaction.from_user_email?.toLowerCase().includes(query) ||
//           transaction.transaction_type?.toLowerCase().includes(query) ||
//           transaction.opening_bal?.toString().includes(query) ||
//           transaction.credit_bal?.toString().includes(query) ||
//           transaction.debit_bal?.toString().includes(query) ||
//           transaction.closing_bal?.toString().includes(query)
//         );
//       }
  
//       // Apply date filter
//       if (dateFilter !== 'all') {
//         const now = new Date();
//         filtered = filtered.filter(transaction => {
//           const transactionDate = new Date(transaction.created_at);
          
//           switch (dateFilter) {
//             case 'today':
//               return transactionDate.toDateString() === now.toDateString();
            
//             case 'week': {
//               const oneWeekAgo = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
//               return transactionDate >= oneWeekAgo;
//             }
            
//             case 'month': {
//               const oneMonthAgo = new Date(now.getFullYear(), now.getMonth() - 1, now.getDate());
//               return transactionDate >= oneMonthAgo;
//             }
            
//             case 'year': {
//               const oneYearAgo = new Date(now.getFullYear() - 1, now.getMonth(), now.getDate());
//               return transactionDate >= oneYearAgo;
//             }
            
//             default:
//               return true;
//           }
//         });
//       }
  
//       return filtered;
//     }, [originalTransactions, searchQuery, dateFilter]);
  

//   useEffect(() => { fetchIncomeData(); }, [currentPage, perPage, incomeType]);

//   const filteredData = useMemo(() => {
//     let filtered = [...transactions];
//     if (searchQuery.trim()) {
//       const q = searchQuery.toLowerCase();
//       filtered = filtered.filter(t => t.transaction_id?.toString().includes(q) || t.from_user_email?.toLowerCase().includes(q));
//     }
//     return filtered;
//   }, [transactions, searchQuery]);

//   const handleDownload = () => {
//     const ws = XLSX.utils.json_to_sheet(filteredData);
//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, 'Report');
//     XLSX.writeFile(wb, `${title}_Report.xlsx`);
//     toast.success("Report Exported");
//   };

//   return (
//       <div className="main-wrapper dark-theme">
//       {/* Sidebar */}
//       <nav className={`sidebar ${sidebarOpen ? '' : 'close'}`}>
//         <div className="sidebar-header">
//           <a href="#" className="sidebar-brand">
//             <i className="me-2" data-lucide="atom"></i>
//             Willow <span>Quantum</span>
//           </a>
//           <div className="sidebar-toggler" onClick={toggleSidebar}>
//             <span></span>
//             <span></span>
//             <span></span>
//           </div>
//         </div>
//         <Sidebar />
//       </nav>

//       <div className="page-wrapper">
//         {/* Navbar - Update to pass toggleSidebar prop */}
//         <Navbar toggleSidebar={toggleSidebar} />
//         <div className="page-content p-4">
//           <div className="d-flex justify-content-between align-items-center mb-4">
//             <h3 className="text-white">{title}</h3>
//           </div>

//          <div className="row mb-4">
//                       <div className="col-md-8">
//                         <div className="d-flex gap-3 search-filter">
//                           <form onSubmit={handleSearch} className="flex-grow-1">
//                             <div className="search-box">
//                               <Search size={18} className="search-icon" />
//                               <input
//                                 type="text"
//                                 className="search-input"
//                                 placeholder="Search by transaction ID, email, or amount..."
//                                 value={searchQuery}
//                                 onChange={(e) => setSearchQuery(e.target.value)}
//                               />
//                               {/* <button type="submit" className="search-btn">
//                                 Search
//                               </button> */}
//                             </div>
//                           </form>
//                           <div className="dropdown">
//                             <button
//                               className="btn btn-outline-light dropdown-toggle"
//                               type="button"
//                               data-bs-toggle="dropdown"
//                             >
//                               <Filter size={16} className="me-2" />
//                               {dateFilter === 'all' ? 'Filter by Date' : dateFilter.charAt(0).toUpperCase() + dateFilter.slice(1)}
//                             </button>
//                             <div className="dropdown-menu">
//                               <button 
//                                 className={`dropdown-item ${dateFilter === 'today' ? 'active' : ''}`}
//                                 onClick={() => handleDateFilterChange('today')}
//                               >
//                                 Today
//                               </button>
//                               <button 
//                                 className={`dropdown-item ${dateFilter === 'week' ? 'active' : ''}`}
//                                 onClick={() => handleDateFilterChange('week')}
//                               >
//                                 This Week
//                               </button>
//                               <button 
//                                 className={`dropdown-item ${dateFilter === 'month' ? 'active' : ''}`}
//                                 onClick={() => handleDateFilterChange('month')}
//                               >
//                                 This Month
//                               </button>
//                               <button 
//                                 className={`dropdown-item ${dateFilter === 'year' ? 'active' : ''}`}
//                                 onClick={() => handleDateFilterChange('year')}
//                               >
//                                 This Year
//                               </button>
//                               <div className="dropdown-divider"></div>
//                               <button 
//                                 className={`dropdown-item ${dateFilter === 'all' ? 'active' : ''}`}
//                                 onClick={() => handleDateFilterChange('all')}
//                               >
//                                 All Time
//                               </button>
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                       <div className="col-md-4">
//                         <div className="d-flex export-page gap-2">
//                           <button 
//                             className="btn btn-outline-light"
//                             onClick={handleDownload}
//                             disabled={filteredTransactions.length === 0}
//                           >
//                             <Download size={16} className="me-2" />
//                             Export ({filteredTransactions.length})
//                           </button>
//                           <div className="dropdown">
//                             <button
//                               className="btn btn-outline-light dropdown-toggle"
//                               type="button"
//                               data-bs-toggle="dropdown"
//                             >
//                               {perPage} per page
//                             </button>
//                             <div className="dropdown-menu">
//                               {[10, 15, 25, 50, 100].map((num) => (
//                                 <button
//                                   key={num}
//                                   className={`dropdown-item ${perPage === num ? 'active' : ''}`}
//                                   onClick={() => {
//                                     setPerPage(num);
//                                     toast.info(`Displaying ${num} transactions per page`);
//                                   }}
//                                 >
//                                   {num} per page
//                                 </button>
//                               ))}
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>

//           <div className="transaction-table-wrapper">
//             {loading ? (
//               <div className="text-center py-5"><div className="spinner-border text-light"></div></div>
//             ) : (
//               <div className="table-responsive">
//                 <table className="transaction-table">
//                   <thead>
//                     <tr>
//                       <th>Transaction ID</th>
//                       <th>Type</th>
//                       <th>From/To</th>
//                       <th>Opening</th>
//                       <th>Amount</th>
//                       <th>Closing</th>
//                       <th>Date</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {filteredData.map((t) => (
//                       <tr key={t.id}>
//                         <td>#{t.transaction_id}</td>
//                         <td className="text-info"><CreditCard size={14} className="me-1"/> {t.transaction_type}</td>
//                         <td>{t.from_user_email || 'System'}</td>
//                         <td>${parseFloat(t.opening_bal).toFixed(2)}</td>
//                         <td className={t.credit_bal > 0 ? "text-green" : "text-red"}>
//                             {t.credit_bal > 0 ? `+$${t.credit_bal}` : `-$${t.debit_bal}`}
//                         </td>
//                         <td>${parseFloat(t.closing_bal).toFixed(2)}</td>
//                         <td><Calendar size={14}/> {new Date(t.created_at).toLocaleDateString()}</td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             )}
//           </div>
//         </div>
//          <footer className="footer-dark">
//           <div className="container">
//             <p className="text-center mb-0 text-white">
//               Copyright © 2025 Willow Quantum. All rights reserved.
//             </p>
//           </div>
//         </footer>
//       </div>
//     </div>
//   );
// };

// export default ZeroIncome;

import React, { useState, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import Sidebar from '../Core/Sidebar';
import Navbar from '../Core/Navbar';
import { Search, Filter, Download, ChevronLeft, ChevronRight, Users, DollarSign, Award, Calendar, Target, Gift, TrendingUp, Zap, Percent } from 'lucide-react';
import * as XLSX from 'xlsx';
import { toast } from 'react-toastify';
import '../../Dashboard Style/WalletTransaction.css';
import { getZeroIncomeBonusApi } from '../../Services/Operations/ProductAPI'; // Import the API

const ZeroIncome = ({ title, incomeType }) => {
  const authToken = useSelector((state) => state.user?.token);
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [bonusData, setBonusData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [perPage, setPerPage] = useState(15);
  const [searchQuery, setSearchQuery] = useState('');
  const [dateFilter, setDateFilter] = useState('all');
  const [totalReceived, setTotalReceived] = useState(0);
  const [totalDistributed, setTotalDistributed] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);

      const [isMobile, setIsMobile] = useState(false);
  
    // Check screen size on mount and resize
    useEffect(() => {
      const checkMobile = () => {
        const mobile = window.innerWidth < 992;
        setIsMobile(mobile);
  
        // Auto-close sidebar on mobile by default
        if (mobile) {
          setSidebarOpen(true);
        } else {
          setSidebarOpen(true);
        }
      };
  
      checkMobile();
      window.addEventListener('resize', checkMobile);
      return () => window.removeEventListener('resize', checkMobile);
    }, []);
  
  
  
    const closeSidebar = () => {
      if (isMobile) {
        setSidebarOpen(false);
      }
    };

  
  // Initialize sidebar functionality
  useEffect(() => {
    const sidebar = document.querySelector('.sidebar');
    const sidebarBody = document.querySelector('.sidebar-body');
    
    if (sidebar) {
      if (sidebarOpen) {
        sidebar.classList.remove('close');
      } else {
        sidebar.classList.add('close');
      }
    }
    
    if (sidebarBody) {
      sidebarBody.style.height = 'calc(100vh - 70px)';
      sidebarBody.style.overflowY = 'auto';
    }

    return () => {
      // Cleanup
    };
  }, [sidebarOpen]);
  
  useEffect(() => {
    // Add custom styles for Zero Income page
    const style = document.createElement('style');
    style.innerHTML = `
      /* Custom scrollbar for sidebar */
      .sidebar-body {
        height: calc(100vh - 70px);
        overflow-y: auto;
      }
      
      .sidebar-body::-webkit-scrollbar {
        width: 6px;
      }
      
      .sidebar-body::-webkit-scrollbar-track {
        background: rgba(255, 255, 255, 0.05);
        border-radius: 10px;
      }
      
      .sidebar-body::-webkit-scrollbar-thumb {
        background: rgba(255, 255, 255, 0.2);
        border-radius: 10px;
      }
      
      .sidebar-body::-webkit-scrollbar-thumb:hover {
        background: rgba(255, 255, 255, 0.3);
      }
      
      /* Zero Income specific styles */
      .zero-income-table {
        background: rgba(30, 30, 40, 0.8);
        border-radius: 12px;
        overflow: hidden;
        border: 1px solid rgba(255, 255, 255, 0.1);
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
      }
      
      .zero-income-table thead th {
        background: linear-gradient(135deg, rgba(76, 175, 80, 0.2) 0%, rgba(139, 195, 74, 0.2) 100%);
        color: #e9ecef;
        font-weight: 700;
        text-transform: uppercase;
        font-size: 13px;
        letter-spacing: 0.8px;
        padding: 18px 15px;
        border-bottom: 2px solid rgba(76, 175, 80, 0.4);
        position: relative;
      }
      
      .zero-income-table thead th:after {
        content: '';
        position: absolute;
        bottom: -2px;
        left: 0;
        width: 100%;
        height: 2px;
        background: linear-gradient(90deg, #4caf50, #8bc34a);
      }
      
      .zero-income-table tbody td {
        padding: 16px 15px;
        vertical-align: middle;
        border-bottom: 1px solid rgba(255, 255, 255, 0.08);
        color: #e9ecef;
        background: rgba(40, 40, 50, 0.5);
        transition: all 0.3s ease;
      }
      
      .zero-income-table tbody tr:nth-child(even) td {
        background: rgba(35, 35, 45, 0.5);
      }
      
      .zero-income-table tbody tr:hover td {
        background: rgba(50, 50, 65, 0.7);
        transform: scale(1.005);
      }
      
      /* Summary cards for zero income */
      .summary-card-zero {
        background: linear-gradient(135deg, rgba(255,255,255,0.05) 0%, rgba(255,255,255,0.02) 100%);
        border-radius: 12px;
        padding: 25px;
        border: 1px solid rgba(255, 255, 255, 0.1);
        transition: all 0.3s ease;
        position: relative;
        overflow: hidden;
      }
      
      .summary-card-zero:before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 4px;
      }
      
      .summary-card-zero.received:before {
        background: linear-gradient(90deg, #4caf50, #8bc34a);
      }
      
      .summary-card-zero.distributed:before {
        background: linear-gradient(90deg, #9c27b0, #673ab7);
      }
      
      .summary-card-zero.total:before {
        background: linear-gradient(90deg, #00bcd4, #0097a7);
      }
      
      .summary-card-zero.achievers:before {
        background: linear-gradient(90deg, #ff9800, #ff5722);
      }
      
      .summary-card-zero:hover {
        transform: translateY(-8px);
        box-shadow: 0 15px 30px rgba(0, 0, 0, 0.4);
      }
      
      /* Icon containers */
      .icon-circle-zero {
        width: 48px;
        height: 48px;
        border-radius: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 15px;
        font-size: 22px;
      }
      
      .icon-circle-zero.received {
        background: linear-gradient(135deg, rgba(76, 175, 80, 0.2), rgba(139, 195, 74, 0.2));
        color: #4caf50;
      }
      
      .icon-circle-zero.distributed {
        background: linear-gradient(135deg, rgba(156, 39, 176, 0.2), rgba(103, 58, 183, 0.2));
        color: #9c27b0;
      }
      
      .icon-circle-zero.total {
        background: linear-gradient(135deg, rgba(0, 188, 212, 0.2), rgba(0, 151, 167, 0.2));
        color: #00bcd4;
      }
      
      .icon-circle-zero.achievers {
        background: linear-gradient(135deg, rgba(255, 152, 0, 0.2), rgba(255, 87, 34, 0.2));
        color: #ff9800;
      }
      
      /* Badge styles */
      .badge-achiever-zero {
        background: linear-gradient(135deg, #00bcd4 0%, #0097a7 100%);
        color: white;
        padding: 6px 12px;
        border-radius: 15px;
        font-size: 12px;
        font-weight: 600;
      }
      
      .badge-user-zero {
        background: linear-gradient(135deg, #9c27b0 0%, #673ab7 100%);
        color: white;
        padding: 6px 12px;
        border-radius: 15px;
        font-size: 12px;
        font-weight: 600;
      }
      
      /* Amount display */
      .amount-display-zero {
        font-weight: 700;
        font-size: 16px;
        padding: 10px 14px;
        border-radius: 10px;
        display: inline-block;
        min-width: 120px;
      }
      
      .amount-received-zero {
        background: linear-gradient(135deg, rgba(76, 175, 80, 0.1), rgba(139, 195, 74, 0.1));
        color: #4caf50;
        border-left: 3px solid #4caf50;
      }
      
      .amount-distributed-zero {
        background: linear-gradient(135deg, rgba(156, 39, 176, 0.1), rgba(103, 58, 183, 0.1));
        color: #9c27b0;
        border-left: 3px solid #9c27b0;
      }
      
      .amount-total-zero {
        background: linear-gradient(135deg, rgba(0, 188, 212, 0.1), rgba(0, 151, 167, 0.1));
        color: #00bcd4;
        border-left: 3px solid #00bcd4;
      }
      
      /* Search box styles */
      .search-box-zero {
        background: rgba(255, 255, 255, 0.05);
        border-radius: 10px;
        padding: 12px 20px;
        border: 1px solid rgba(255, 255, 255, 0.1);
        display: flex;
        align-items: center;
        transition: all 0.3s ease;
      }
      
      .search-box-zero:focus-within {
        border-color: #4caf50;
        box-shadow: 0 0 0 3px rgba(76, 175, 80, 0.2);
      }
      
      .search-box-zero input {
        background: transparent;
        border: none;
        color: white;
        flex: 1;
        padding: 0 15px;
        outline: none;
        font-size: 14px;
      }
      
      .search-box-zero input::placeholder {
        color: rgba(255, 255, 255, 0.5);
      }
      
      /* Pagination styles */
      .pagination-container-zero {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px;
        background: rgba(30, 30, 40, 0.8);
        border-radius: 10px;
        border: 1px solid rgba(255, 255, 255, 0.1);
        margin-top: 20px;
      }
      
      .pagination-info-zero {
        color: #adb5bd;
        font-size: 14px;
        font-weight: 500;
      }
      
      .pagination-buttons-zero .btn {
        margin: 0 4px;
        min-width: 40px;
        height: 40px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        font-weight: 600;
        transition: all 0.3s ease;
      }
      
      .pagination-buttons-zero .btn:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
      }
      
      .page-numbers-zero {
        display: flex;
        gap: 5px;
      }
      
      /* User ID display */
      .user-id-display-zero {
        background: linear-gradient(135deg, rgba(255,255,255,0.03) 0%, rgba(255,255,255,0.01) 100%);
        border-radius: 8px;
        padding: 10px;
        border: 1px solid rgba(255, 255, 255, 0.1);
      }
      
      .user-id-label-zero {
        font-size: 11px;
        color: #8b949e;
        text-transform: uppercase;
        letter-spacing: 0.5px;
      }
      
      .user-id-value-zero {
        font-size: 14px;
        font-weight: 700;
        color: #58a6ff;
      }
      
      /* Text colors */
      .text-received-zero { color: #4caf50 !important; }
      .text-distributed-zero { color: #9c27b0 !important; }
      .text-total-zero { color: #00bcd4 !important; }
      .text-achiever-zero { color: #ff9800 !important; }
      .text-zero-primary { color: #4caf50 !important; }
      .text-zero-secondary { color: #00bcd4 !important; }
      
      /* Progress bar styles */
      .progress-zero {
        height: 6px;
        background-color: rgba(255, 255, 255, 0.1);
        border-radius: 3px;
        overflow: hidden;
      }
      
      .progress-bar-zero {
        background: linear-gradient(90deg, #4caf50, #8bc34a);
        height: 100%;
        border-radius: 3px;
        transition: width 0.3s ease;
      }
      
      /* Distribution rate display */
      .distribution-rate {
        background: rgba(156, 39, 176, 0.1);
        border-radius: 8px;
        padding: 8px 12px;
        border: 1px solid rgba(156, 39, 176, 0.3);
      }
      
      .distribution-rate-value {
        font-size: 18px;
        font-weight: 700;
        color: #9c27b0;
      }
      
      .distribution-rate-label {
        font-size: 11px;
        color: #b39ddb;
        text-transform: uppercase;
        letter-spacing: 0.5px;
      }
    `;
    document.head.appendChild(style);
    
    // Fetch data on component mount
    fetchZeroIncomeBonus();

    return () => {
      document.head.removeChild(style);
    };
  }, [currentPage, perPage, authToken]);

    const toggleSidebar = () => {
      setSidebarOpen(!sidebarOpen);
    };
  
    // Initialize sidebar functionality
    useEffect(() => {
      const sidebar = document.querySelector('.sidebar');
      const sidebarBody = document.querySelector('.sidebar-body');
      
      if (sidebar) {
        if (sidebarOpen) {
          sidebar.classList.remove('close');
        } else {
          sidebar.classList.add('close');
        }
      }
      
      if (sidebarBody) {
        sidebarBody.style.height = 'calc(100vh - 70px)';
        sidebarBody.style.overflowY = 'auto';
      }
  
      return () => {};
    }, [sidebarOpen]);
  
    useEffect(() => {
      const style = document.createElement('style');
      style.innerHTML = `
        .sidebar-body {
          height: calc(100vh - 70px);
          overflow-y: auto;
        }
        
        .sidebar-body::-webkit-scrollbar {
          width: 6px;
        }
        
        .sidebar-body::-webkit-scrollbar-track {
          background: rgba(255, 255, 255, 0.05);
          border-radius: 10px;
        }
        
        .sidebar-body::-webkit-scrollbar-thumb {
          background: rgba(255, 255, 255, 0.2);
          border-radius: 10px;
        }
        
        .sidebar-body::-webkit-scrollbar-thumb:hover {
          background: rgba(255, 255, 255, 0.3);
        }
        
        .sidebar .nav-dropdown {
          list-style: none;
          padding-left: 0;
          max-height: 0;
          overflow: hidden;
          transition: max-height 0.3s ease;
        }
        
        .sidebar .nav-dropdown.show {
          max-height: 500px;
        }
        
        .sidebar .nav-dropdown-item {
          padding-left: 2.5rem;
        }
        
        .nav-item.has-dropdown .nav-link {
          position: relative;
          padding-right: 2.5rem;
        }
        
        .nav-item.has-dropdown .dropdown-icon {
          position: absolute;
          right: 1rem;
          top: 50%;
          transform: translateY(-50%);
          transition: transform 0.3s ease;
        }
        
        .nav-item.has-dropdown .nav-link[aria-expanded="true"] .dropdown-icon {
          transform: translateY(-50%) rotate(180deg);
        }
        
        .nav-item.has-dropdown .nav-dropdown {
          background: rgba(255, 255, 255, 0.05);
          border-left: 3px solid var(--primary-color, #0d6efd);
          margin-left: 1rem;
          border-radius: 0 0 8px 8px;
        }
        
        .nav-item.has-dropdown .nav-dropdown-item .nav-link {
          padding: 0.75rem 1rem 0.75rem 2rem;
          color: rgba(255, 255, 255, 0.8);
        }
        
        .nav-item.has-dropdown .nav-dropdown-item .nav-link:hover {
          background: rgba(255, 255, 255, 0.1);
          color: white;
        }
        
        .nav-item.has-dropdown .link-title.nav-item.nav-category {
          font-weight: 600;
          font-size: 0.875rem;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }
        
        .sidebar {
          transition: all 0.3s ease;
        }
      `;
      document.head.appendChild(style);
  
      return () => {
        document.head.removeChild(style);
      };
    }, []);
  
  const fetchZeroIncomeBonus = async () => {
    try {
      setLoading(true);
      const result = await getZeroIncomeBonusApi(authToken, currentPage, perPage);
      
      if (result.status) {
        setBonusData(result.data);
        setTotalPages(result.pagination.last_page || 1);
        
        // Calculate totals
        const receivedTotal = result.data.reduce((sum, item) => 
          sum + (parseFloat(item.received_amount) || 0), 0);
        const distributedTotal = result.data.reduce((sum, item) => 
          sum + (parseFloat(item.distribute_amount) || 0), 0);
        const amountTotal = result.data.reduce((sum, item) => 
          sum + (parseFloat(item.total_amount) || 0), 0);
        
        setTotalReceived(receivedTotal);
        setTotalDistributed(distributedTotal);
        setTotalAmount(amountTotal);
        
        toast.success(result.message || 'Zero income bonus loaded successfully');
      } else {
        toast.error(result.message || 'Failed to load zero income bonus');
      }
    } catch (error) {
      console.error('Error fetching zero income bonus:', error);
      toast.error('Network error. Please check your connection.');
    } finally {
      setLoading(false);
    }
  };
  
  const handleSearch = (e) => {
    e.preventDefault();
    // Search is handled by filteredData memo
  };
  
  const handleDateFilterChange = (filter) => {
    setDateFilter(filter);
    setCurrentPage(1);
    toast.info(`Date filter changed to ${filter === 'all' ? 'All Time' : filter}`);
  };
  
  const filteredData = useMemo(() => {
    let filtered = [...bonusData];
    
    // Apply search filter
    if (searchQuery.trim()) {
      const query = searchQuery.toLowerCase();
      filtered = filtered.filter(item => 
        item.id?.toString().toLowerCase().includes(query) ||
        item.user_id?.toString().toLowerCase().includes(query) ||
        item.transaction_id?.toString().toLowerCase().includes(query) ||
        item.total_amount?.toString().includes(query) ||
        item.distribute_amount?.toString().includes(query) ||
        item.received_amount?.toString().includes(query)
      );
    }
    
    // Apply date filter
    if (dateFilter !== 'all') {
      const now = new Date();
      filtered = filtered.filter(item => {
        const itemDate = new Date(item.created_at);
        
        switch (dateFilter) {
          case 'today':
            return itemDate.toDateString() === now.toDateString();
          case 'week': {
            const oneWeekAgo = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
            return itemDate >= oneWeekAgo;
          }
          case 'month': {
            const oneMonthAgo = new Date(now.getFullYear(), now.getMonth() - 1, now.getDate());
            return itemDate >= oneMonthAgo;
          }
          case 'year': {
            const oneYearAgo = new Date(now.getFullYear() - 1, now.getMonth(), now.getDate());
            return itemDate >= oneYearAgo;
          }
          default:
            return true;
        }
      });
    }
    
    return filtered;
  }, [bonusData, searchQuery, dateFilter]);
  
  const handleDownload = () => {
    if (filteredData.length === 0) {
      toast.warning('No data to export');
      return;
    }
    
    const exportData = filteredData.map((item, index) => ({
      'ID': item.id,
      'User ID': item.user_id,
      'Transaction ID': item.transaction_id,
      'Total Achiever': item.total_achiever,
      'Total Users': item.total_users,
      'Total Amount': `$${parseFloat(item.total_amount || 0).toFixed(2)}`,
      'Distribute Amount': `$${parseFloat(item.distribute_amount || 0).toFixed(2)}`,
      'Received Amount': `$${parseFloat(item.received_amount || 0).toFixed(2)}`,
      'Created At': item.created_at
    }));
    
    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Zero Income Bonus');
    XLSX.writeFile(wb, `Zero_Income_Bonus_${new Date().toISOString().split('T')[0]}.xlsx`);
    toast.success('Zero income bonus report exported successfully!');
  };
  
  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(prev => prev - 1);
    }
  };
  
  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(prev => prev + 1);
    }
  };
  
  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  
  // Format date function
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };
  
  // Calculate achievement ratio
  const calculateAchievementRatio = (achiever, total) => {
    if (total === 0) return '0%';
    return `${((achiever / total) * 100).toFixed(1)}%`;
  };

  // Calculate distribution rate
  const calculateDistributionRate = (distributed, total) => {
    if (total === 0) return '0%';
    return `${((distributed / total) * 100).toFixed(2)}%`;
  };

  // Generate page numbers for pagination
  const getPageNumbers = () => {
    const pageNumbers = [];
    const maxPagesToShow = 5;
    
    if (totalPages <= maxPagesToShow) {
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      if (currentPage <= 3) {
        for (let i = 1; i <= 5; i++) {
          pageNumbers.push(i);
        }
      } else if (currentPage >= totalPages - 2) {
        for (let i = totalPages - 4; i <= totalPages; i++) {
          pageNumbers.push(i);
        }
      } else {
        for (let i = currentPage - 2; i <= currentPage + 2; i++) {
          pageNumbers.push(i);
        }
      }
    }
    
    return pageNumbers;
  };

  // Calculate total achievers and users
  const calculateTotals = () => {
    const totalAchievers = bonusData.reduce((sum, item) => sum + (item.total_achiever || 0), 0);
    const totalUsers = bonusData.reduce((sum, item) => sum + (item.total_users || 0), 0);
    return { totalAchievers, totalUsers };
  };

  const { totalAchievers, totalUsers } = calculateTotals();

  return (
    <div className="main-wrapper dark-theme">
      {/* Sidebar */}
      <nav className={`sidebar ${sidebarOpen ? '' : 'close'}`}>
        <div className="sidebar-header">
          <a href="#" className="sidebar-brand">
            <i className="me-2" data-lucide="atom"></i>
            Willow <span>Quantum</span>
          </a>
          <div className="sidebar-toggler" onClick={toggleSidebar}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
        <Sidebar
                          isOpen={!sidebarOpen}
                          onClose={closeSidebar}
                        />
              
                        {/* Mobile backdrop */}
                        {isMobile && sidebarOpen && (
                          <div
                            className="sidebar-backdrop"
                            onClick={closeSidebar}
                          />
                        )}
             </nav>
       
             <div className="page-wrapper">
               <Navbar toggleSidebar={toggleSidebar}  isSidebarOpen={sidebarOpen}
                   isMobile={isMobile}/>
       
        
        <div className="page-content p-4">
          {/* Page Header */}
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div>
              <h3 className="text-white fw-bold mb-1">{title}</h3>
              <p className="text-muted mb-0">Track your zero-level income bonus achievements</p>
            </div>
            <div>
              <span className="badge bg-gradient-success px-3 py-2">
                <Zap size={16} className="me-2" />
                Zero Level Bonus
              </span>
            </div>
          </div>
          
          {/* Summary Cards */}
          <div className="row mb-4">
            <div className="col-md-3">
              <div className="summary-card-zero received">
                <div className="d-flex align-items-center">
                  <div className="icon-circle-zero received">
                    <DollarSign size={24} />
                  </div>
                  <div>
                    <h6 className="text-muted mb-1">Total Received</h6>
                    <h3 className="text-white mb-0 text-received-zero">${totalReceived.toFixed(2)}</h3>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="summary-card-zero distributed">
                <div className="d-flex align-items-center">
                  <div className="icon-circle-zero distributed">
                    <Gift size={24} />
                  </div>
                  <div>
                    <h6 className="text-muted mb-1">Total Distributed</h6>
                    <h3 className="text-white mb-0 text-distributed-zero">${totalDistributed.toFixed(2)}</h3>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="summary-card-zero total">
                <div className="d-flex align-items-center">
                  <div className="icon-circle-zero total">
                    <Award size={24} />
                  </div>
                  <div>
                    <h6 className="text-muted mb-1">Total Bonus Pool</h6>
                    <h3 className="text-white mb-0 text-total-zero">${totalAmount.toFixed(2)}</h3>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="summary-card-zero achievers">
                <div className="d-flex align-items-center">
                  <div className="icon-circle-zero achievers">
                    <Target size={24} />
                  </div>
                  <div>
                    <h6 className="text-muted mb-1">Achievement Rate</h6>
                    <h3 className="text-white mb-0 text-achiever-zero">
                      {calculateAchievementRatio(totalAchievers, totalUsers)}
                    </h3>
                    <small className="text-muted">
                      {totalAchievers} of {totalUsers} users
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          {/* Search and Filter Section */}
          <div className="row mb-4">
            <div className="col-md-8">
              <div className="d-flex gap-3">
                <form onSubmit={handleSearch} className="flex-grow-1">
                  <div className="search-box-zero">
                    <Search size={18} className="text-muted me-2" />
                    <input
                      type="text"
                      placeholder="Search by ID, user ID, or amount..."
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />
                  </div>
                </form>
                <div className="dropdown">
                  <button
                    className="btn btn-outline-light dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown"
                  >
                    <Filter size={16} className="me-2" />
                    {dateFilter === 'all' ? 'All Time' : dateFilter.charAt(0).toUpperCase() + dateFilter.slice(1)}
                  </button>
                  <div className="dropdown-menu">
                    <button 
                      className={`dropdown-item ${dateFilter === 'today' ? 'active' : ''}`}
                      onClick={() => handleDateFilterChange('today')}
                    >
                      Today
                    </button>
                    <button 
                      className={`dropdown-item ${dateFilter === 'week' ? 'active' : ''}`}
                      onClick={() => handleDateFilterChange('week')}
                    >
                      This Week
                    </button>
                    <button 
                      className={`dropdown-item ${dateFilter === 'month' ? 'active' : ''}`}
                      onClick={() => handleDateFilterChange('month')}
                    >
                      This Month
                    </button>
                    <button 
                      className={`dropdown-item ${dateFilter === 'year' ? 'active' : ''}`}
                      onClick={() => handleDateFilterChange('year')}
                    >
                      This Year
                    </button>
                    <div className="dropdown-divider"></div>
                    <button 
                      className={`dropdown-item ${dateFilter === 'all' ? 'active' : ''}`}
                      onClick={() => handleDateFilterChange('all')}
                    >
                      All Time
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="d-flex justify-content-end gap-2">
                <button 
                  className="btn btn-outline-light"
                  onClick={handleDownload}
                  disabled={filteredData.length === 0}
                >
                  <Download size={16} className="me-2" />
                  Export ({filteredData.length})
                </button>
                <div className="dropdown">
                  <button
                    className="btn btn-outline-light dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown"
                  >
                    {perPage} per page
                  </button>
                  <div className="dropdown-menu">
                    {[10, 15, 25, 50, 100].map((num) => (
                      <button
                        key={num}
                        className={`dropdown-item ${perPage === num ? 'active' : ''}`}
                        onClick={() => {
                          setPerPage(num);
                          setCurrentPage(1);
                          toast.info(`Displaying ${num} records per page`);
                        }}
                      >
                        {num} per page
                      </button>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          {/* Table Section */}
          <div className="zero-income-table">
            {loading ? (
              <div className="text-center py-5">
                <div className="spinner-border text-zero-primary" style={{ width: '3rem', height: '3rem' }} role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
                <p className="mt-3 text-white">Loading zero income bonus data...</p>
              </div>
            ) : (
              <div className="table-responsive">
                <table className="table table-hover mb-0">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>USER ID</th>
                  
                      <th>ACHIEVERS / USERS</th>
                      <th>TOTAL AMOUNT</th>
                      <th>DISTRIBUTE AMOUNT</th>
                      <th>RECEIVED AMOUNT</th>
                      <th>CREATED AT</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredData.length === 0 ? (
                      <tr>
                        <td colSpan="8" className="text-center py-5">
                          <div className="text-muted">
                            <Zap size={48} className="mb-3 opacity-50 text-zero-primary" />
                            <h5 className="text-white">No zero income bonus found</h5>
                            <p className="text-muted mb-0">Reach zero-level achievements to earn bonuses</p>
                          </div>
                        </td>
                      </tr>
                    ) : (
                      filteredData.map((item, index) => (
                        <tr key={item.id} className="border-bottom border-dark">
                          {/* ID */}
                          <td className="align-middle">
                            <div className="d-flex align-items-center">
                              <div className="bg-dark text-white rounded-circle d-flex align-items-center justify-content-center me-2" 
                                   style={{ width: '32px', height: '32px', fontSize: '14px', fontWeight: '700', background: 'linear-gradient(135deg, #4caf50 0%, #8bc34a 100%)' }}>
                                {(currentPage - 1) * perPage + index + 1}
                              </div>
                              {/* <span className="text-white fw-bold fs-6">#{item.id}</span> */}
                            </div>
                          </td>
                          
                          {/* USER ID */}
                          <td className="align-middle">
                            <div className="user-id-display-zero">
                              {/* <div className="user-id-label-zero">User ID</div> */}
                              <div className="user-id-value-zero d-flex align-items-center">
                                {/* <Users size={14} className="me-2" /> */}
                                {item.user_id}
                              </div>
                            </div>
                          </td>
                          
                          {/* ACHIEVERS / USERS */}
                          <td className="align-middle">
                            <div className="d-flex flex-column align-items-center">
                              <div className="d-flex gap-2 mb-2">
                                <span className="badge-achiever-zero d-flex align-items-center">
                                  <Target size={12} className="me-1" />
                                  {item.total_achiever} Achievers
                                </span>
                                <span className="badge-user-zero d-flex align-items-center">
                                  <Users size={12} className="me-1" />
                                  {item.total_users} Users
                                </span>
                              </div>
                              {/* <div className="progress-zero" style={{ width: '100%', marginBottom: '5px' }}>
                                <div 
                                  className="progress-bar-zero" 
                                  role="progressbar" 
                                  style={{ width: `${item.total_users > 0 ? (item.total_achiever / item.total_users) * 100 : 0}%` }}
                                ></div>
                              </div>
                              <small className="text-muted">
                                {calculateAchievementRatio(item.total_achiever, item.total_users)} Achievement
                              </small> */}
                            </div>
                          </td>
                          
                          {/* TOTAL AMOUNT */}
                          <td className="align-middle">
                            <div className="amount-display-zero amount-total-zero">
                              <div className="d-flex align-items-center">
                                <Award size={16} className="me-2" />
                                <div>
                                  <div className="fw-bold">${parseFloat(item.total_amount || 0).toFixed(2)}</div>
                                  {/* <small className="text-muted">Bonus Pool</small> */}
                                </div>
                              </div>
                            </div>
                          </td>
                          
                          {/* DISTRIBUTE AMOUNT */}
                          <td className="align-middle">
                            <div className="amount-display-zero amount-distributed-zero">
                              <div className="d-flex align-items-center">
                                <Gift size={16} className="me-2" />
                                <div>
                                  <div className="fw-bold">${parseFloat(item.distribute_amount || 0).toFixed(2)}</div>
                                  {/* <small className="text-muted">To Distribute</small> */}
                                </div>
                              </div>
                              {/* {item.total_amount > 0 && (
                                <div className="distribution-rate mt-2">
                                  <div className="distribution-rate-value text-center">
                                    {calculateDistributionRate(item.distribute_amount, item.total_amount)}
                                  </div>
                                  <div className="distribution-rate-label text-center">Distribution Rate</div>
                                </div>
                              )} */}
                            </div>
                          </td>
                          
                          {/* RECEIVED AMOUNT */}
                          <td className="align-middle">
                            <div className="amount-display-zero amount-received-zero">
                              <div className="d-flex align-items-center">
                                {/* <DollarSign size={16} className="me-2" /> */}
                                <div>
                                  <div className="fw-bold">${parseFloat(item.received_amount || 0).toFixed(2)}</div>
                                  {/* <small className="text-muted">You Received</small> */}
                                </div>
                              </div>
                              {/* {item.distribute_amount > 0 && (
                                <div className="mt-2 text-center">
                                  <small className="text-muted">
                                    <Percent size={10} className="me-1" />
                                    {calculateDistributionRate(item.received_amount, item.distribute_amount)} of distributed
                                  </small>
                                </div>
                              )} */}
                            </div>
                          </td>
                          
                          {/* CREATED AT */}
                          <td className="align-middle">
                            <div className="bg-dark border border-secondary border-opacity-25 p-3 rounded-3">
                              {/* <div className="d-flex align-items-center mb-2">
                                <Calendar size={16} className="me-2 text-primary" />
                                <span className="text-white small fw-semibold">Created</span>
                              </div> */}
                              <div className="text-white small">{formatDate(item.created_at)}</div>
                            </div>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            )}
          </div>
          
          {/* Pagination */}
          {!loading && filteredData.length > 0 && (
            <div className="pagination-container-zero">
              <div className="pagination-info-zero">
                Showing {(currentPage - 1) * perPage + 1} to {Math.min(currentPage * perPage, filteredData.length)} of {filteredData.length} entries
              </div>
              <div className="pagination-buttons-zero">
                <button
                  className="btn btn-outline-light"
                  onClick={handlePrevPage}
                  disabled={currentPage === 1}
                >
                  <ChevronLeft size={16} /> Prev
                </button>
                
                <div className="page-numbers-zero d-inline-block mx-2">
                  {getPageNumbers().map((pageNum) => (
                    <button
                      key={pageNum}
                      className={`btn ${currentPage === pageNum ? 'btn-success' : 'btn-outline-light'}`}
                      onClick={() => handlePageClick(pageNum)}
                    >
                      {pageNum}
                    </button>
                  ))}
                  
                  {totalPages > 5 && currentPage < totalPages - 2 && (
                    <>
                      <span className="mx-2 text-muted">...</span>
                      <button
                        className="btn btn-outline-light"
                        onClick={() => handlePageClick(totalPages)}
                      >
                        {totalPages}
                      </button>
                    </>
                  )}
                </div>
                
                <button
                  className="btn btn-outline-light"
                  onClick={handleNextPage}
                  disabled={currentPage === totalPages}
                >
                  Next <ChevronRight size={16} />
                </button>
              </div>
            </div>
          )}
        </div>
        
        {/* Footer */}
        <footer className="footer d-flex flex-row align-items-center justify-content-center px-4 py-3 border-top small">
          <p className="text-secondary mb-1 mb-md-0">Copyright © 2025 Willow Quantum. All Right Reserved.</p>
        </footer>
      </div>
    </div>
  );
};

export default ZeroIncome;